<template>
    <div class="contact" :class="stepActive == 1 ? 'bg-gray' : ''">
        <div class="top">
            <div class="title">Online Assessment</div>
        </div>
        <div class="con">
            <div class="title">
                Australia Spouse Application Initial Assessment Form
                <br>
                （Overseas 309/100 or Domestic 820/801 or Prospective Spouse Visa 300）
            </div>
        </div>
        <div class="step">
            <el-steps :active="stepActive" align-center finish-status="success">
                <el-step title="Evaluation Questions"></el-step>
                <el-step title="Personal Information"></el-step>
                <el-step title="Submission Success"></el-step>
            </el-steps>
        </div>
        <div v-if="stepActive == 0">
            <div class="form">
                <div class="form-list" v-for="item in questionList">
                    <div class="form-title">{{ item.title }}:</div>
                    <div class="question-lists">
                        <div class="question-list" v-for="question in item.children">
                            <div class="question-title">{{ question.name }}:</div>
                            <el-radio-group v-if="question.type == 'radio'" v-model="question.active">
                                <el-radio v-for="option in question.option" :key="option.name" :label="option.name">
                                    {{ option.name }}
                                </el-radio>
                            </el-radio-group>
                            <el-checkbox-group v-if="question.type == 'checkbox'" v-model="question.active">
                                <el-checkbox v-for="option in question.option" :key="option.name" :label="option.name">
                                    {{ option.name }}
                                </el-checkbox>
                            </el-checkbox-group>
                            <div class="tip" v-if="question.tip">{{ question.tip }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="btn-con">
                <el-button type="primary" class="btn" @click="submitForm">Submit</el-button>
            </div>

        </div>
        <div v-if="stepActive == 1">
            <div class="step1">
                <!-- <p class="score">您的评分：<span>{{ totalScore }}</span>分</p> -->
                <div class="step-1">
                    <div class="input-title"><span>*</span>Name</div>
                    <el-input placeholder="Please enter your name" v-model="form.name"></el-input>
                    <div class="input-title"><span>*</span>Email</div>
                    <el-input placeholder="Please enter your email" v-model="form.email"></el-input>
                    <div class="input-title"><span>*</span>Mobile</div>
                    <el-input placeholder="Please enter your mobile number" v-model="form.mobile"></el-input>
                    <div class="input-title">Source</div>
                    <el-input placeholder="Please enter your source" v-model="form.source"></el-input>
                    <div class="input-title">Nationality</div>
                    <el-input placeholder="Please enter your nationality" v-model="form.nationality"></el-input>
                    <div class="input-title">Guarantor Identity</div>
                    <el-select placeholder="Please select your guarantor identity" v-model="form.guarantor">
                        <el-option label="Australian Citizen" value="Australian Citizen"></el-option>
                        <el-option label="Australian PR" value="Australian PR"></el-option>
                        <el-option label="New Zealand Citizen" value="New Zealand Citizen"></el-option>
                    </el-select>
                    <div class="input-title"><span>*</span>WeChat Account</div>
                    <el-input placeholder="Please enter your WeChat account" v-model="form.wx_code"></el-input>
                    <div class="input-title">Message</div>
                    <el-input placeholder="Please enter your message" v-model="form.about"></el-input>
                    <div class="input-title">Attachment</div>
                    <el-radio v-model="form.reportType" label="1">Upload Image</el-radio>
                    <el-radio v-model="form.reportType" label="2">Upload File</el-radio>
                    <el-upload ref="child1" class="upload-demo"
                        :action="form.reportType == 1 ? host + '/VisApi/uploadImg' : host + '/VisApi/uploadfile'"
                        :on-success="successReport1" :before-remove="removeReport1" :file-list="fileList"
                        :accept="form.reportType == 1 ? '.png, .jpg' : '.rar, .zip, .xls, .xlsx, .doc, .docx'"
                        :before-upload="beforeAvatarUpload1" :on-exceed="onExceedFn1" :limit="1">
                        <el-button type="primary">Click to upload</el-button>
                        <template #tip>
                            <div class="el-upload__tip">
                                Only upload {{ form.reportType == 1 ? 'png, jpg' : "rar, zip, xls, xlsx, doc, docx" }}
                                files
                            </div>
                        </template>
                    </el-upload>
                </div>
            </div>
            <div class="btn-con">
                <el-button type="primary" class="btn" @click="backFn(0)">Back to Evaluation Questions</el-button>
                <el-button type="primary" class="btn" @click="subFn">Submit</el-button>
            </div>
        </div>
        <div v-if="stepActive == 2">
            <p class="step2">
                Thank you for your trust! Your information has been successfully submitted! <br>
                We have received your evaluation information. We will contact you as soon as possible to provide
                preliminary
                conclusions and suggestions. <br>
                If urgent processing is required, please indicate "urgent" in the message and specify the reason. The
                New Legend
                Visa Service Team is happy to assist you. <br>
                Our team comprises officially certified registered migration agents from Australia and New Zealand, who
                have
                been in the industry for 10 years and have achieved positive results for over 30,000 clients. <br>
                We are in Sydney, and our working hours are from 9:00 am to 5:30 pm Sydney time. You are also welcome to
                add our
                customer service WeChat for timely communication.
                <img class="sandywx" src="../../assets/imgs/sandywx.png" alt="">
                <el-button type="primary" class="btn" @click="stepActive = 0">Retry</el-button>
            </p>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            totalScore: 0,
            stepActive: 2,
            questionList: [
                {
                    "title": "Visa Path Selection",
                    "children": [
                        {
                            "name": "Application Channel",
                            "type": "radio",
                            "tip": "",
                            "active": [],
                            "option": [
                                { "name": "Overseas：309/100" },
                                { "name": "Domestic：820/801" },
                                { "name": "Single Couple Visa：300" },
                                { "name": "Unknown" }
                            ]
                        },
                        {
                            "name": "Has Children",
                            "type": "radio",
                            "tip": "",
                            "active": [],
                            "option": [
                                { "name": "No" },
                                { "name": "Yes, children under 18 years old" },
                                { "name": "Yes, children over 18 years old" }
                            ]
                        },
                        {
                            "name": "Current Location",
                            "type": "radio",
                            "tip": "",
                            "active": [],
                            "option": [
                                { "name": "Both in Australia or overseas" },
                                { "name": "One in Australia, one overseas overseas" },
                                { "name": "Both overseas overseas" }
                            ]
                        },
                        {
                            "name": "Relationship Type",
                            "type": "radio",
                            "tip": "",
                            "active": [],
                            "option": [
                                { "name": "Married" },
                                { "name": "De facto partner" },
                                { "name": "Planned marriage" }
                            ]
                        },
                        {
                            "name": "Guarantor Type",
                            "type": "radio",
                            "tip": "",
                            "active": [],
                            "option": [
                                { "name": "PR" },
                                { "name": "Australian Citizen" },
                                { "name": "New Zealand Citizen" },
                                { "name": "Unknown" }
                            ]
                        },
                        {
                            "name": "Guarantor Has Guarantees",
                            "type": "radio",
                            "tip": "",
                            "active": [],
                            "option": [
                                { "name": "No" },
                                { "name": "1 time" },
                                { "name": "2 times" },
                                { "name": "3 times or more" },
                                { "name": "Unknown" }
                            ]
                        },
                        {
                            "name": "Guarantor Visa Status",
                            "type": "radio",
                            "tip": "",
                            "active": [],
                            "option": [
                                { "name": "In Australia" },
                                { "name": "Overseas, no Australian rejection" },
                                { "name": "Overseas, Australian rejection" },
                                { "name": "No visa in Australia" }
                            ]
                        }
                    ]
                },
                {
                    "title": "Relationship Stability Evidence",
                    "children": [
                        {
                            "name": "Relationship Duration",
                            "type": "radio",
                            "tip": "",
                            "active": [],
                            "option": [
                                { "name": "Under 6 months" },
                                { "name": "Under 12 months" },
                                { "name": "12-24 months" },
                                { "name": "2-5 years" }
                            ]
                        },
                        {
                            "name": "Has Living Together",
                            "type": "radio",
                            "tip": "",
                            "active": [],
                            "option": [
                                { "name": "Cohabitation (over 6 months)" },
                                { "name": "Cohabitation (under 6 months)" },
                                { "name": "Unknown" }
                            ]
                        },
                        {
                            "name": "Common Financial Accounts",
                            "type": "radio",
                            "tip": "",
                            "active": [],
                            "option": [
                                { "name": "Yes" },
                                { "name": "No" },
                                { "name": "Unknown" }
                            ]
                        },
                        {
                            "name": "Common Living Contract",
                            "type": "radio",
                            "tip": "",
                            "active": [],
                            "option": [
                                { "name": "Joint rental/billing/insurance/travel" },
                                { "name": "No joint rental contract" },
                                { "name": "Meeting less than once a month" }
                            ]
                        },
                        {
                            "name": "Family and Friends Approval",
                            "type": "radio",
                            "tip": "",
                            "active": [],
                            "option": [
                                { "name": "Possessing a plethora of group photos and social proof" },
                                { "name": "General" },
                                { "name": "less" }
                            ]
                        },
                        {
                            "name": "Marriage Plan",
                            "type": "radio",
                            "tip": "",
                            "active": [],
                            "option": [
                                { "name": "Registered marriage" },
                                { "name": "Defacto" },
                                { "name": "No marriage no defacto only living together" }
                            ]
                        },
                        {
                            "name": "Has Children Together",
                            "type": "radio",
                            "tip": "",
                            "active": [],
                            "option": [
                                { "name": "None" },
                                { "name": "have (common children)" },
                                { "name": "Yes (stepchildren)" }
                            ]
                        }
                    ]
                },
                {
                    "title": "Risk Assessment",
                    "children": [
                        {
                            "name": "Has Separation",
                            "type": "radio",
                            "tip": "",
                            "active": [],
                            "option": [
                                { "name": "None" },
                                { "name": "Yes (explainable separation with evidence)" },
                                { "name": "Unknown" }
                            ]
                        },
                        {
                            "name": "Whether there is a history of divorce/previous marriage",
                            "type": "radio",
                            "tip": "",
                            "active": [],
                            "option": [
                                { "name": "None" },
                                { "name": "Yes (formalities have been completed, both parties are single)" },
                                { "name": "Yes (the process is in progress, divorce has not been finalized)" }
                            ]
                        },
                        {
                            "name": "Whether there is a history of visa rejection or cancellation in Australia",
                            "type": "radio",
                            "tip": "",
                            "active": [],
                            "option": [
                                { "name": "None" },
                                { "name": "Yes (needs to be disclosed and evaluated)" }
                            ]
                        },
                        {
                            "name": "Whether it involves complex situations",
                            "type": "radio",
                            "tip": "",
                            "active": [],
                            "option": [
                                { "name": "None" },
                                { "name": "with (age difference, language barrier, flash marriage, long-term cross-border separation, etc.)" },
                                { "name": "The guaranteed person is stranded in Australia without an Australian visa or holds a bridging visa as a refugee" }
                            ]
                        }
                    ]
                }
            ],
            host: "/api",
            form: {
                name: '',
                email: '',
                mobile: '',
                reviewFileUrl: '',
                about: '',
                type_id: 5,
                reportType: '2',
                source: '',
                wx_code: '',
                nationality: '',
                guarantor: '',
            },
            file_url: [],
            fileList: [],
            loading: false,
        };
    },
    mounted() {
        this.stepActive = 0
    },
    methods: {
        backFn(index) {
            this.stepActive = index;
            window.scrollTo(0, 0);
        },
        onExceedFn1() {
            this.$message.error("Only one file can be uploaded");
        },
        successReport1(a, b) {
            console.log(a, '-----1--21-1-1aaa');
            this.file_url = a.data;
            this.fileList.push(a.data);
            this.$message.success("Upload successful");
            this.loading = false;
        },
        removeReport1() {
            this.file_url = [];
            this.fileList = [];
        },
        handleRemove1() {
            this.file_url = [];
            this.fileList = [];
        },
        beforeAvatarUpload1(rawFile) { },
        subFn() {
            if (!this.form.name) {
                this.$message.error('Please enter your name')
                return
            }
            if (!this.form.email) {
                this.$message.error('Please enter your email')
                return
            }
            if (!this.form.wx_code) {
                this.$message.error('Please enter your WeChat account number')
                return
            }
            this.$http.review_add5({
                name: this.form.name,
                email: this.form.email,
                mobile: this.form.mobile,
                about: this.form.about,
                type_id: this.form.type_id,
                reviewtext: JSON.stringify(this.questionList),
                reviewNum: this.score,
                reviewFileUrl: this.file_url,
                source: this.form.source,
                wx_code: this.form.wx_code,
                nationality: this.form.nationality,
                guarantor: this.form.guarantor,
            }).then(res => {
                console.log(res, '------')
                this.$message.success('Submission successful')
                this.stepActive = 2;
            })
        },
        submitForm() {
            // 计算总分
            // let totalScore = 0;
            // this.questionList.forEach(questionItem => {
            //     if (!Array.isArray(questionItem.children)) return;
            //     questionItem.children.forEach(child => {
            //         const optionScoreMap = child.option.reduce((map, option) => {
            //             const validScore = Number(option.score) || 0;
            //             map[option.name] = validScore;
            //             return map;
            //         }, {});
            //         switch (child.type) {
            //             case 'radio':
            //                 totalScore += optionScoreMap[child.active] || 0;
            //                 break;
            //             case 'checkbox':
            //                 child.active.forEach(activeName => {
            //                     totalScore += optionScoreMap[activeName] || 0;
            //                 });
            //                 break;
            //             default:
            //                 console.warn(`未处理的题型：${child.type}`, child);
            //                 break;
            //         }
            //     });
            // });
            this.stepActive = 1;
            window.scrollTo(0, 0);
            // this.totalScore = totalScore;
        },
    }
}
</script>

<style lang="less" scoped>
.bg-gray {
    background-color: #f1f1f1;
    padding-bottom: 10px;
}

.upload-demo {
    margin-top: 20px;
    margin-bottom: 40px;
}

.btn-con {
    margin: 0 auto 150px;
    display: flex;
    justify-content: center;
}

.contact {
    .step2 {
        margin: 50px auto 100px;
        font-size: 18px;
        text-align: center;

        .sandywx {
            width: 200px;
            height: 200px;
            display: block;
            margin: 10px auto 0;
        }

        .btn {
            margin: 20px auto 0;
        }
    }

    .step {
        max-width: 700px;
        margin: 30px auto;
    }

    .step1 {
        margin: 0 auto 70px;
        max-width: 600px;
        background-color: #fff;
        padding: 20px 40px;
        border-radius: 10px;

        .score {
            font-size: 20px;

            span {
                margin-right: 6px;
                color: #222222;
                font-size: 30px;
                font-weight: 500;
            }
        }

        .input-title {
            margin-top: 40px;
            color: #333;

            span {
                color: red;
                margin-right: 4px;
            }
        }
    }

    .btn {
        display: block;
    }

    .form {
        max-width: 900px;
        margin: 0 auto;
        margin-bottom: 50px;
        border: 1px solid #ccc;
        background-color: #fff;

        .form-title {
            font-size: 26px;
            font-weight: 500;
            margin: 20px 0;
            text-indent: 20px;
            color: #333;
        }

        .question-lists {
            display: flex;
            flex-wrap: wrap;
        }

        .question-list {
            width: 100%;
            display: inline-block;
            box-sizing: border-box;
            padding: 20px;
            line-height: 30px;
            border-bottom: 1px solid #ccc;
            background-color: #f1f1f1;
        }

        .question-list:nth-child(2n) {
            border-left: 1px solid #ccc;
        }

        .tip {
            font-size: 14px;
            line-height: 20px;
            color: #222222;
        }

        .question-title {
            font-size: 20px;
            margin-bottom: 10px;
        }
    }

    .con {
        max-width: 1200px;
        margin: 50px auto;
        box-sizing: border-box;
    }

    .title {
        font-size: 30px;
        font-weight: 600;
        text-align: center;
        margin: 20px 0;
    }

    .text {
        width: 100%;
        padding: 0 20px;
        box-sizing: border-box;

        p {
            font-size: 16px;
            line-height: 30px;
            margin: 10px 0;
        }

        .border {
            border: 1px solid #ccc;
            padding: 10px;
            margin: 10px 0;
            border-radius: 10px;

            p {
                font-size: 14px;
                line-height: 20px;
                margin: 10px 0;
            }
        }
    }

    .top {
        width: 100vw;
        height: 300px;
        position: relative;
        overflow: hidden;
        background-image: url('../../assets/imgs/concat_us.png');
        background-size: cover;
        transition: .3s all;
        background-position: center;

        .title {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            font-size: 60px;
            font-weight: 600;
            letter-spacing: 2px;
            color: #222222;
            text-shadow: 3px 3px 5px #fff;
        }



        img {
            width: 100%;
            object-fit: cover;
            height: 100%;
            transition: .3s all;
        }

        &:hover {
            background-size: cover;

            img {
                transform: scale(1.1);
            }
        }
    }

}


@media (max-width: 600px) {
    .contact {
        .top {
            height: 200px;

            .title {
                font-size: 30px;
            }
        }

        .con {
            padding: 0 20px;
        }

        .title {
            font-size: 20px;
        }

        .step {
            zoom: 0.7;
        }

        .step1 {
            padding: 10px 20px;
        }

        .step2 {
            font-size: 18px;
            margin: 100px auto 150px;
        }

        .step2+.btn {
            margin: 0 auto 30px;
        }

        .form {
            padding: 0 15px;
            box-sizing: border-box;

            .question-list {
                padding: 10px;
            }

            .form-title {
                font-size: 20px;
            }

            .question-title {
                font-size: 16px;
            }

            .question-list:nth-child(2n) {
                border-left: none;
            }

            .question-list {}
        }

        .text p {
            font-size: 14px;
        }

        .text {
            padding: 0;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/views/en/evaluate.vue